module.exports = __webpack_public_path__ + "static/media/IMG_3372.8ad7bb80.JPG";